import { z } from 'zod';
/** Route params for the endpoints addressing one keyword within an organization. */
export const OrganizationClinicalKeywordParamsSchema = z
    .object({ organizationId: z.uuid(), id: z.uuid() })
    .strict();
const keyword = z
    .object({
    category: z.string().min(1),
    aliases: z.array(z.string().min(1)),
    searchable: z.boolean(),
    keyword: z.string().min(1),
})
    .strict();
/**
 * One keyword or a batch of them: the route answers an object with an object and an array with an
 * array, so the two shapes stay one contract rather than two endpoints.
 */
export const OrganizationClinicalKeywordUpsertSchema = z.union([keyword, z.array(keyword)]);
//# sourceMappingURL=clinicalKeyword.js.map